import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOAD_COURSES, UPDATE_COURSE, HARD_DELETE_COURSE } from './constants';
import {
  loadCoursesSuccess,
  loadCoursesError,
  updateCourseSuccess,
  updateCourseError,
  hardDeleteCourseSuccess,
  hardDeleteCourseError
} from './actions';

import history from 'utils/history';
import requestUtil from 'utils/request';
import requestWrapper from 'utils/requestWrapper';

export function* loadCourses() {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));

    // we get the campaigns linked to the courses
    const itemsList = yield requestWrapper('GET', `courses/list`, '', currentUser.token);

    if (!itemsList) {
      yield put(loadCoursesSuccess(false));
    } else {
      const firstElem = itemsList.data[0];
      yield put(loadCoursesSuccess(itemsList, firstElem));
    }
  } catch (error) {
    yield put(loadCoursesError(error));
  }
}

export function* updateCourse(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { courseDetail } = action;

    let updatedCourse = false,
      isNew = !courseDetail.hasOwnProperty('_id');
    
    if (isNew) {
      updatedCourse = yield requestWrapper(
        'POST',
        'courses/new/',
        courseDetail,
        currentUser.token,
      );
    } else {
      updatedCourse = yield requestWrapper(
        'PATCH',
        `courses/`,
        courseDetail,
        currentUser.token,
      );
    }

    if (!updatedCourse) {
      yield put(updateCourseSuccess(false));
    } else if ( updatedCourse.hasOwnProperty('data') || updatedCourse.hasOwnProperty('code') ) {
      yield put(updateCourseSuccess(updatedCourse));
      updatedCourse?.data && history.push({ pathname: `/сours/${updatedCourse?.data?._id}` });
    } else {
      // if new we update the url, item props will be updated
      if (isNew && updatedCourse._id) {
        history.push({ pathname: `/сours/${updatedCourse._id}` });
      }
      yield put(updateCourseSuccess(updatedCourse));
    }

  } catch (err) {
    yield put(updateCourseError(true));
  }
}

export function* hardDeleteCourseSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { hardDeleteCourseId } = action;

    const hardDelteCourse = yield requestWrapper(
        'PATCH',
        `courses/delete`,
        { objects: [hardDeleteCourseId] },
        currentUser.token,
      );

    if (!hardDelteCourse) {
      yield put(hardDeleteCourseSuccess(false));
    } else {
      yield put(hardDeleteCourseSuccess(hardDelteCourse));
    }

  } catch (err) {
    yield put(hardDeleteCourseError(err));
  }
}

// Individual exports for testing
export default function* coursesSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_COURSES, loadCourses);
  yield takeLatest(UPDATE_COURSE, updateCourse);
  yield takeLatest(HARD_DELETE_COURSE, hardDeleteCourseSaga);
}
